<div class="content p-l">
  <div class="flex-row">
    <!-- first details + statistics section-->
    <div class="detail-col flex-col flex-basis-1-1-auto">
      @if (component) {
      <app-component-detail-card
        class="mb-m mr-m"
        [solution]="solutionSpace"
        [component]="component"
      ></app-component-detail-card>
      }

      <mat-card class="info-card flex-basis-1 mat-p-overwite mr-m">
        @if (solutionSpace === 'utilization') {
        <div class="flex-row space-between mb-xl">
          <span class="auto-margin-top-bottom humidity-title capitalize">{{ solutionSpace }}</span>
        </div>
        <div class="mb-xl days-row">
          <div>
            <div class="grey-title grey mb-s mt-l1">
              {{ "component.DETAILS.OVERVIEW.UTILIZATION_STATISTICS_TITLE" | translate }}
            </div>
            @if (utilizationStatistics$ | async; as utilizationStatistics) {
            <div class="flex days-value">
              <div style="font-weight: 700; font-size: 36px; letter-spacing: 0.25; padding-right: 4px">
                {{
                  utilizationStatistics.daysAvailable +
                    utilizationStatistics.daysInUse +
                    utilizationStatistics.daysInReturn +
                    utilizationStatistics.daysInService
                }}
              </div>
              <div class="prefix">{{ "SHARED.DAYS" | translate }}</div>
            </div>
            }
          </div>
          @if (utilizationStatistics$ | async; as utilizationStatistics) {
          <div class="turns-inline">
            <div class="grey-title grey mb-s">Turns</div>
            <div class="turns-value">
              <span>{{ utilizationStatistics.cycles }}</span>
              <svg-icon
                src="/assets/icons/loop.svg"
                [svgStyle]="{ 'width.px': 18, 'height.px': 18, fill: '#ff6400' }"
              ></svg-icon>
            </div>
          </div>
          }
        </div>
        <div>
          @if (utilizationStatistics$ | async; as utilizationStatistics) {
          <app-utilization-statistics [data]="utilizationStatistics"></app-utilization-statistics>
          }
        </div>
        } @if (solutionSpace === 'humidity') {
        <div class="flex-row space-between mb-l">
          <span class="humidity-title">{{
            "component.DETAILS.OVERVIEW.HUMIDITY_AND_TEMPERATURE_TITLE" | translate
          }}</span>
          <div class="flex-row">
            <polytech-ui-date-picker
              (dateChanged)="updateDateRange($event, 'MEASUREMENTS')"
              initialTimeRange="14"
              [canAlwaysConfirm]="true"
              timeZone="Africa/Abidjan"
              #datePickerHumRef
            >
              <ng-container>
                <dt (click)="datePickerHumRef.setDefinedRange('14d')">
                  {{ "SHARED.LAST_COMMUNICATED.14_DAYS" | translate }}
                </dt>
                <dt (click)="datePickerHumRef.setDefinedRange('3m')">
                  {{ "SHARED.LAST_COMMUNICATED.3_MONTHS" | translate }}
                </dt>
                <dt (click)="datePickerHumRef.setDefinedRange('6m')">
                  {{ "SHARED.LAST_COMMUNICATED.6_MONTHS" | translate }}
                </dt>
                <dt (click)="selectAllData()">{{ "SHARED.LAST_COMMUNICATED.ALL_TIME" | translate }}</dt>
              </ng-container>
            </polytech-ui-date-picker>
          </div>
        </div>
        <mat-card-content>
          @if (isMetDataLoading) {
          <div class="chart-spinner-wrapper">
            <mat-spinner diameter="48"></mat-spinner>
          </div>
          } @if (metData$ | async; as metData) {
          <app-meteorology-chart [hidden]="isMetDataLoading" [data]="metData"></app-meteorology-chart>
          }
        </mat-card-content>
        }
      </mat-card>
    </div>
    <div
      style="padding-bottom: 0px !important; min-height: 100%"
      class="detail-col detail-col-half flex-basis-1-1-auto"
    >
      @if (component) {
      <app-recent-history
        [isHistoryLoaded]="isActivitiesLoaded"
        [timeline]="(activities$ | async) ?? undefined"
        [component]="component"
        [showCreateActivityButton]="!isProjectComponent"
        (activityCreated)="onActivityCreated()"
      ></app-recent-history>
      }
    </div>
  </div>
  <!-- maptrack section -->
  <div class="br-8 info-card maptrack-card">
    <mat-sidenav-container class="full-height br-8 sidenav-container" autosize>
      <mat-sidenav
        class="sidenav-drawer"
        [opened]="isTableOpen"
        [mode]="bp.isCompact() ? 'over' : 'side'"
        [disableClose]="!bp.isCompact()"
        (closedStart)="isTableOpen = false"
      >
        @if (bp.isCompact()) {
        <!-- the drawer covers the map (and its toggle) below 1024px, so the handle sits on the drawer's right edge -->
        <button
          type="button"
          class="btn-toggle btn-toggle-drawer"
          aria-expanded="true"
          [attr.aria-label]="'SHARED.TOGGLE_LIST' | translate"
          (click)="toggle()"
        >
          <svg-icon src="/assets/icons/icon-40-collapse.svg" [class]="'icon-mobile'"></svg-icon>
        </button>
        }
        <div class="flex-col drawer-body">
          <section>
            <span class="auto-margin-top-bottom humidity-title">
              {{ "component.DETAILS.OVERVIEW.TABLE.TITLE" | translate }}
            </span>
            <div class="form-container" style="display: flex">
              <div class="form-field-container pr-s main-page flex-child-100">
                <app-filter
                  [filterOptions]="filtersOptions"
                  [toggleSearchBar]="false"
                  (updateData)="updateData($event)"
                ></app-filter>
              </div>
            </div>
          </section>
          <section class="scroll_table">
            @if (isMaptrackLoaded) {
            <app-table
              [tableCols]="displayedColumns"
              [dataSource]="dataSource"
              (rowClicked)="addTrackPointToMap($event)"
              class="max-height"
            ></app-table>
            @if (allTrackingPoints.length === 0) {
            <div style="text-align: center; padding-top: 64px">
              <h2>{{ "component.DETAILS.OVERVIEW.TABLE.NO_DATA_HEADER" | translate }}</h2>
              @if ( dataSource.length === 0 && (currentFilter.lastCommunicationTimeFrom === undefined ||
              currentFilter.lastCommunicationTimeTo === undefined) && shortcutFilter.value !== 'All' ) {
              <h4 class="text-empty-label mb-m">
                {{ "component.DETAILS.OVERVIEW.TABLE.NO_DATA_INFO" | translate }}
              </h4>
              <button
                mat-flat-button
                style="background-color: #4682b4; color: white"
                (click)="setFilterDateRange(shortcutFilter.value)"
              >
                {{ shortcutFilter.text | translate }}
              </button>
              }
            </div>
            } }
          </section>
          @if (!isMaptrackLoaded) {
          <h4 style="margin: auto; padding-top: 64px" class="text-empty-label">
            {{ "component.DETAILS.OVERVIEW.TABLE.LOADING_DATA" | translate }}
          </h4>
          <mat-spinner class="spinner-position"></mat-spinner>
          }
        </div>
      </mat-sidenav>
      <mat-sidenav-content style="position: relative">
        @if (markerData) {
        <app-map-view
          mapId="map-track-detail"
          [markerData]="markerData"
          [routeData]="routeData"
          [hasRouting]="true"
        ></app-map-view>
        }
        <button
          type="button"
          class="btn-toggle"
          [attr.aria-expanded]="isTableOpen"
          [attr.aria-label]="'SHARED.TOGGLE_LIST' | translate"
          (click)="toggle()"
        >
          @if (isTableOpen) {
          <svg-icon src="/assets/icons/icon-40-collapse.svg" [class]="'icon-mobile'"></svg-icon>
          } @if (!isTableOpen) {
          <svg-icon src="/assets/icons/icon-40-expand.svg" [class]="'icon-mobile'"></svg-icon>
          }
        </button>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>
